var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "messages-block"
    }
  }, [_c('h1', {
    attrs: {
      "id": "messages-block-header"
    }
  }, [_vm._v("Messages")]), _vm._v(" "), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.items,
      "fields": _vm.fields,
      "id": _vm.tableId,
      "show-empty": "",
      "sticky-header": true,
      "no-sort-reset": true,
      "busy": _vm.isBusy
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function () {
        return [_vm._t("table-busy", function () {
          return [_c('raft-busy', {
            attrs: {
              "busy-text": "Loading..."
            }
          })];
        })];
      },
      proxy: true
    }, {
      key: "empty",
      fn: function () {
        return [_vm._t("empty", function () {
          return [_c('div', {
            staticClass: "empty-text"
          }, [_vm._v("There are currently no messages to list.")])];
        })];
      },
      proxy: true
    }, {
      key: "cell(subject)",
      fn: function (data) {
        return [_c('div', [_c('a', {
          staticClass: "message-view-link",
          attrs: {
            "href": '/raft/message-center/message/' + data.item.id + '/view'
          }
        }, [_vm._v(_vm._s(data.item.subject))])])];
      }
    }], null, true)
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.viewInboxLink
    }
  }, [_vm._v("View Entire Inbox")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }